import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { throwIfAlreadyLoaded } from './guard/module-import.guard';
import { HttpInterceptorModule, HttpRequestInterceptor } from './interceptors/http-request.interceptor';
import { SecurityInterceptorModule } from './interceptors/security.interceptor';

@NgModule({
  imports: [HttpClientModule, HttpInterceptorModule, SecurityInterceptorModule],
  exports: [],
  providers: []
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
